import { render, staticRenderFns } from "./create_menu.vue.js?vue&type=template&id=41665b2e!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_menu.vue?vue&type=template&id=41665b2e"
import script from "./create_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_menu.vue?vue&type=script&lang=js"
export * from "./create_menu.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41665b2e')) {
      api.createRecord('41665b2e', component.options)
    } else {
      api.reload('41665b2e', component.options)
    }
    module.hot.accept("./create_menu.vue.js?vue&type=template&id=41665b2e!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./create_menu.vue?vue&type=template&id=41665b2e", function () {
      api.rerender('41665b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "super_sidebar/components/create_menu.vue"
export default component.exports